var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F1F5FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1818 15.5C25.6337 15.5 26 15.8358 26 16.25C26 16.6297 25.6922 16.9435 25.2928 16.9932L25.1818 17H14.8182C14.3663 17 14 16.6642 14 16.25C14 15.8703 14.3078 15.5565 14.7072 15.5068L14.8182 15.5H25.1818Z",
    fill: "#99A2AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1818 19.5C25.6337 19.5 26 19.8358 26 20.25C26 20.6297 25.6922 20.9435 25.2928 20.9932L25.1818 21H14.8182C14.3663 21 14 20.6642 14 20.25C14 19.8703 14.3078 19.5565 14.7072 19.5068L14.8182 19.5H25.1818Z",
    fill: "#99A2AD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4545 23.5C21.7558 23.5 22 23.8358 22 24.25C22 24.6297 21.7948 24.9435 21.5286 24.9932L21.4545 25H14.5455C14.2442 25 14 24.6642 14 24.25C14 23.8703 14.2052 23.5565 14.4714 23.5068L14.5455 23.5H21.4545Z",
    fill: "#99A2AD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.f37f21de05b1af4122a4199d2b01c783.svg";
export { ForwardRef as ReactComponent };